import ProfileSection from './ProfileSection';
import 'static/style/profile.scss'
export default (ProfileSection );